export default class Locale_Announcements {
	Content: string = "Content";
	InsertHTMLContentHere: string = "Insert HTML Content here.";
	OnlyActiveItemsWillBeShown: string = "Only active items will be shown";
	RecipientFilter: string = "Recipient Filter";
	AnnouncementFilterDescription: string = "Announcements will only be shown for resources that match this filter. If not defined, the announcement will be shown to all users.";
	AnnouncementsDisplayedInAscending: string = "Announcements will be displayed in ascending order.";
	NameValidation: string = "Name cannot be empty";
	ContentValidation: string = "Content cannot be empty";
}